"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETH_TICKERS = void 0;
const eth_token_1 = require("./eth-token");
const ticker_1 = require("./ticker");
exports.ETH_TICKERS = [ticker_1.Ticker.ETH, ...eth_token_1.ETH_TOKEN_TICKERS];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXRoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RpY2tlcnMvZXRoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLDJDQUErQztBQUMvQyxxQ0FBaUM7QUFFcEIsUUFBQSxXQUFXLEdBQUcsQ0FBQyxlQUFNLENBQUMsR0FBRyxFQUFFLEdBQUcsNkJBQWlCLENBQUMsQ0FBQSJ9